import { Component, OnInit, Input, Output, ViewChild, HostListener, ElementRef, EventEmitter } from '@angular/core';
import { RequestService } from '../../services/request/request.service';
import { AlertBannerService, AlertType } from "../../lib/alert-banner";
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-background-check-filter-modal',
  templateUrl: './background-check-filter-modal.component.pug',
  styleUrls: ['./background-check-filter-modal.component.scss'],
  standalone: false
})

export class BackgroundCheckFilterModalComponent implements OnInit {

  @Output() filterUpdate = new EventEmitter();
  @ViewChild('backgroundCheckFilter', { static: false }) filterDropdown: any;
  filterData: any;
  filterCount = 0;
  filterEnabled = false;
  selectedRegions: any[] = [];
  selectedCheckTypes: any[] = [];
  regions: any[] = [];
  checkTypes: any[] = [];
  regionPlaceholder = $localize`Select available regions`;
  checkTypePlaceholder = $localize`Select check types`;


  @HostListener('document:click', ['$event'])
  clickout(event) {
    const isInsideFilterDropdown = this.eRef.nativeElement.contains(event.target) || (event.path && event.path[0].id === 'filters');
    const isInsideNgSelect = event.path && event.path.some(el => {
      return el.classList && (el.classList.contains('ng-dropdown-panel') || el.classList.contains('ng-value'));
    });

    if (!isInsideFilterDropdown && !isInsideNgSelect) {
      this.filterDropdown?.hide();
    }
    else {
      this.getFiltersData()
    }
  }

  constructor(private eRef: ElementRef, private requestService: RequestService, private alertList: AlertBannerService, private permissionsService: PermissionsService) {
  }

  ngOnInit(): void {
  }

  getFiltersData() {
    this.requestService.getEnhancedBackgroundChecksList().subscribe(response => {
      this.filterData = response['data']['background_checks'];
      let total = response['data']['total'];
      this.prepareFilterData();
    }, error => {
      console.log(error);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    });
  }

  prepareFilterData() {
    this.filterData.forEach((check) => {
      check.config.regions.forEach((region) => {
        const regionObject = { name: region };
        if (!this.regions.some((r) => r.name === regionObject.name)) {
          this.regions.push(regionObject);
        }
      });
      check.config.categories.forEach((category) => {
        const categoryObject = { name: category };
        if (!this.checkTypes.some((c) => c.name === categoryObject.name)) {
          this.checkTypes.push(categoryObject);
        }
      });
    });
  }

  selectRegions(selectedRegions) {
    this.selectedRegions = selectedRegions;
  }

  selectCheckTypes(selectedCheckTypes) {
    this.selectedCheckTypes = selectedCheckTypes;
  }

  reset() {
    this.selectedRegions.forEach(element => {
      element.checked = false
    });
    this.selectedCheckTypes.forEach(element => {
      element.checked = false
    });
    this.selectedRegions = [];
    this.selectedCheckTypes = [];

    this.filterEnabled = false;
  }

  setFilterCount(checkFilterActive, regionFilterActive) {
    this.filterCount = 0;
    if (checkFilterActive) {
      this.filterCount += 1;
      this.filterEnabled = true;
    }
    if (regionFilterActive) {
      this.filterCount += 1;
      this.filterEnabled = true;
    }
  }

  update(event) {
    const checkFilter = this.selectedCheckTypes.length > 0;
    const regionFilter = this.selectedRegions.length > 0;
    this.setFilterCount(checkFilter, regionFilter);
    this.filterDropdown?.hide();
    this.filterUpdate.emit({ 'selected_regions': this.selectedRegions, 'selected_check_types': this.selectedCheckTypes });
  }

}
